<template>
	<v-app theme="light" style="background-color: #eeeeee">
		<nav-bar-portal />
		<VMain>
			<v-container fluid class="pt-0">
				<v-row>
					<v-col cols="12">
						<v-row
							align="center"
							justify="center"
							class="darkColor--text grey lighten-5 rounded mx-5 py-2"
						>
							<v-col cols="12">
								<h1 style="margin: auto">
									<!-- <v-icon class="grey--text text--lighten-1 mt-16 mt-md-0" style="font-size: 2em">fas fa-face-smile-beam</v-icon>
									<br /> -->
									Good {{ getGreetingTime() }}, {{ clientName }}!
								</h1>
								<!-- <v-menu
									offset-y
									class="h-100 mx-5"
									open-on-hover
									right
									v-model="teamMenuActive"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											:ripple="false"
											v-bind="attrs"
											v-on="on"
											x-large
											height="auto"
											light
											elevation="0"
											outlined
											absolute 
											top 
											right
											class="text-left py-md-2 mx-4 px-md-4 text-transform-none rounded-lg float-right"
										>
											<div class="pa-1 mr-3">
												<b> {{ clientName }} Team </b>
												<small style="display: block;">
													{{ clientUserCount
													}}{{
														clientUserCount == 0
															? "Overview"
															: clientUserCount == 1
															? " member"
															: " members"
													}}
												</small>
											</div>
											<v-icon right small v-if="teamMenuActive">
												fas fa-chevron-up
											</v-icon>
											<v-icon right small v-else>
												fas fa-chevron-down
											</v-icon>
										</v-btn>
									</template>
									<v-list class="py-0">
										<v-list-item to="/team">
											<v-list-item-title>See team members</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu> -->
							</v-col>
							<v-col style="display: flex; padding-top: 0; padding-bottom: 0;">
								<v-col cols="7" class="pa-0">
									<h3 class="pl-6 font-weight-high"
										v-if="getNotifications.length > 0">
										Here's what happened while you were away:
									</h3>
									<notifications
										shouldDisplaySingle
										:shouldMarkAsRead="false"
										:maxNotifications= 4
										:isPortalPage="true"
									></notifications>
								</v-col>
								<v-col cols="1"></v-col>
								<v-col style="margin-right: 5px">		
									<router-link :to="'/team/' + username" 
										style="text-decoration: none; color: black;  float: right; border: black 1px solid; padding: 5px 10px; border-radius: 4px;">
										<h3 style="cursor: pointer;"> {{ name }}</h3>
									</router-link>

									<v-text class="mt-5 ml-1 pa-3" style="float: left; border-radius: 5px; background: #00800006;">
										At Orixe, we believe that ethical supply chains are the foundation of a sustainable future. By fostering transparency and trust, we enable businesses
										to not only meet today's demands for accountability but also lead the way in creating a positive legacy for people and the planet.
										<h3 class="mt-5 primary--text" style="float: right;">
											"Is your supply chain Orixed?"</h3>
									</v-text>
									
									<v-btn
										color="#DE8F18"
										class="white--text mt-5"
										style="width: 162px; font-size: 1em; height: 30px; float: right;"
										@click="dialogSupport()"
									>
										FAQ & Support
									</v-btn>
								</v-col>
							</v-col>
						</v-row>

						<v-row
							justify="center"
							align="center"
							class="grey lighten-5 rounded mx-5 my-3"
							style="padding-left: 6%; padding-right: 6%;"
						>
							<v-col cols="12" class="flex-grow-0 mt-2 pa-0">
								<h2 class="text-center pb-0">Modules</h2>
							</v-col>
							<v-col class="flex-grow-0 mt-0">
								<v-tooltip bottom :open-on-hover="!auditUnlocked">
									<template v-slot:activator="{ on, attrs }">
										<v-card
											width="150px"
											height="150px"
											class="ma-3 pa-6 text-center white"
											v-bind="attrs"
											v-on="on"
											v-bind:class="{
												portaldisabled: !auditUnlocked
											}"
											light
											v-bind:to="auditUnlocked ? '/audit' : null"
										>
											<v-img
												alt="Audit Icon"
												:src="require('../assets/Modules/Audit.svg')"
												:aspect-ratio="1"
												width="75"
												class="mx-auto audit-icon"
											/>
											<h4 class="mt-3">Audit</h4>
											<v-card-actions class="pt-0 pr-0 mb-3">
												<v-spacer></v-spacer>
												<v-icon v-if="!auditUnlocked" medium right>
													fas fa-lock
												</v-icon>
											</v-card-actions>
										</v-card>
									</template>
									<span>Contact us to get started with Audit!</span>
								</v-tooltip>
							</v-col>
							<v-col class="flex-grow-0 mt-0">
								<v-tooltip bottom :open-on-hover="!auditFlowDownUnlocked">
									<template v-slot:activator="{ on, attrs }">
										<v-card
											width="150px"
											height="150px"
											class="ma-3 pa-6 text-center white"
											v-bind="attrs"
											v-on="on"
											v-bind:class="{
												portaldisabled: !auditFlowDownUnlocked
											}"
											light
											v-bind:to="auditFlowDownUnlocked ? '/auditflowdown' : null"
										>
											<v-img
												alt="Audit Icon"
												:src="require('../assets/Modules/Audit.svg')"
												:aspect-ratio="1"
												width="75"
												class="mx-auto audit-icon"
											/>
											<h4 class="mt-1">Audit Flow-Down</h4>
											<v-card-actions class="pt-0 pr-0 mb-3">
												<v-spacer></v-spacer>
												<v-icon v-if="!auditFlowDownUnlocked" medium right>
													fas fa-lock
												</v-icon>
											</v-card-actions>
										</v-card>
									</template>
									<span>Contact us to get started with Audit!</span>
								</v-tooltip>
							</v-col>
							<v-col class="flex-grow-0">
								<v-tooltip bottom :disabled="traceUnlocked">
									<template v-slot:activator="{ on, attrs }">
										<v-card
											width="150px"
											height="150px"
											class="ma-3 pa-6 text-center white "
											v-bind="attrs"
											v-on="on"
											v-bind:class="{
												portaldisabled: !traceUnlocked
											}"
											light
											v-bind:to="traceUnlocked ? '/trace' : null"
										>
											<v-img
												alt="Trace Icon"
												:src="require('../assets/Modules/Trace.svg')"
												:aspect-ratio="1"
												width="75"
												class="mx-auto"
											/>
											<h4 class="mt-3">Trace</h4>
											<v-card-actions class="pt-0 pr-0 mb-3">
												<v-spacer></v-spacer>
												<v-icon v-if="!traceUnlocked" medium right
													>fas fa-lock</v-icon
												>
											</v-card-actions>
										</v-card>
									</template>
									<span>Contact us to get started with Trace!</span>
								</v-tooltip>
							</v-col>
							<v-col class="flex-grow-0" v-if="true">
								<v-card
									v-if="true"
									@click="redirect('/csr')"
									width="150px"
									height="150px"
									class="ma-3 pa-6 text-center"
									light
								>
									<v-img
										alt="Sustainability Icon"
										:src="require('../assets/Modules/Sustainability.svg')"
										:aspect-ratio="1"
										width="75"
										class="mx-auto"
									/>
									<h4 class="mt-3">Sustainability</h4>
								</v-card>
							</v-col>
							<v-col class="flex-grow-0" v-if="true">
								<v-card
									v-if="true"
									@click="redirect('/emissions')"
									width="150px"
									height="150px"
									class="ma-3 pa-6 text-center"
									light
								>
									<v-img
										alt="Sustainability Icon"
										:src="require('../assets/Modules/Ikon_CO2_Modul.svg')"
										:aspect-ratio="1"
										width="75"
										class="mx-auto"
									/>
									<h4 class="mt-1">Co2 Calculator</h4>
								</v-card>
							</v-col>
							<!-- <v-col class="flex-grow-0">
								<v-card
									to="/chain"
									target="_blank"
									width="150px"
									height="150px"
									class="ma-3 pa-6 text-center "
									color="white"
									light
								>
									<v-img
										alt="Chain Icon"
										:src="require('../assets/Modules/Chain.svg')"
										:aspect-ratio="1"
										width="75"
										class="mx-auto"
									/>
									<h4 class="mt-2">Chain</h4>
									<v-card-actions class="pt-0 pr-0 mb-3">
										<v-spacer></v-spacer>
										<v-icon small right color="darkColor"
											>fas fa-external-link-alt</v-icon
										>
									</v-card-actions>
								</v-card>
							</v-col> -->
							<v-col class="flex-grow-0">
								<v-tooltip bottom :disabled="connectionsUnlocked">
									<template v-slot:activator="{ on, attrs }">
										<v-card
											width="150px"
											height="150px"
											class="ma-3 pa-6 text-center"
											v-bind="attrs"
											v-on="on"
											v-bind:class="{
												portaldisabled: !connectionsUnlocked
											}"
											light
											v-bind:to="connectionsUnlocked ? '/connections' : null"
										>
											<v-img
												alt="Connections Icon"
												:src="require('../assets/Modules/Connections.svg')"
												:aspect-ratio="1"
												width="75"
												class="mx-auto"
											/>
											<h4 class="mt-3">Connections</h4>
											<v-card-actions class="pt-0 pr-0 mb-3">
												<v-spacer></v-spacer>
												<v-icon v-if="!connectionsUnlocked" medium right
													>fas fa-lock</v-icon
												>
											</v-card-actions>
										</v-card>
									</template>
									<span>Contact us to get started with Trace!</span>
								</v-tooltip>
							</v-col>
							<v-col class="flex-grow-0">
								<v-card
									width="150px"
									height="150px"
									class="ma-3 pa-6 text-center white"
									light
									to="/supplier-performance"
								>
									<v-img
										alt="Supplier Performance Icon"
										:src="require('../assets/Modules/SupplierPerformance.svg')"
										:aspect-ratio="1"
										width="75"
										class="mx-auto"
									/>
									<h4 class="mt-1">Supplier Performance</h4>
								</v-card>
							</v-col>
							<v-col class="flex-grow-0" v-if="true">
								<v-card
									v-if="true"
									@click="redirect('/ProductPlan')"
									width="150px"
									height="150px"
									class="ma-3 pa-6 text-center"
									light
								>
									<v-img
										alt="Account Icon"
										:src="require('../assets/Modules/Account.svg')"
										:aspect-ratio="1"
										width="75"
										class="mx-auto"
									/>
									<h4 class="mt-3">Product Plans</h4>
								</v-card>
							</v-col>
							<v-col class="flex-grow-0" v-if="false">
								<v-card
									@click="$store.dispatch('user/refreshToken')"
									width="200px"
									height="200px"
									class="ma-3 pa-6 text-center"
									color="white"
									light
								>
									<v-icon size="75" class="mb-3">fas fa-cog</v-icon>
									<h2 class="mt-3">Refresh Token</h2>
								</v-card>
							</v-col>
							<!-- Tmp disable billing portal -->
							<!-- <v-col class="flex-grow-0" v-if="false">
								<v-card
									:href="billingPortalURL"
									width="150px"
									height="150px"
									class="ma-3 pa-6 text-center"
									color="trace darken-2"
									dark
								>
									<v-icon size="75" class="mb-3">fas fa-money-check</v-icon>
									<h2>Manage Billing</h2>
								</v-card>
							</v-col> -->
							<!-- <v-col class="flex-grow-0" v-if="billingPortalURL2 ">
								<v-card
									:href="billingPortalURL2"
									width="150px"
									height="150px"
									class="ma-3 pa-6 text-center"
									color="trace darken-2"
									light
								>
									<v-icon size="75" class="mb-3">fas fa-money-check</v-icon>
									<h2>Bill</h2>
								</v-card>
							</v-col> -->
						</v-row>

						<v-row
							justify="space-around"
							class="grey lighten-5 rounded mx-5 mb-3"
						>
							<v-col cols="6" class="pa-0 d-flex flex-column mb-20">
								<supplier-csr
									:isPortalView="true"
									:score1="csrScore[0]"
									:score2="csrScore[1]"
									:score3="csrScore[2]"
									:score4="csrScore[3]"
									:title="`Sustainability for ${clientName}`"
									class="sustainabilityScore"
								/>
								<v-btn style=" width: 75%; align-self: center; margin-bottom: 50px; margin-top: -30px;" color="primary" to="/csr/submit"
									:disabled="csrScore[0] >0"
								> 
									<v-icon left>fas fa-user-friends</v-icon>
									<span>Get the Sustainability score for your company</span>
								</v-btn>
							</v-col>
							<v-col cols="6" class="pa-0 d-flex flex-column">
								<supplier-csr
									:isPortalView="true"
									:score1="csrAverageScore[0]"
									:score2="csrAverageScore[1]"
									:score3="csrAverageScore[2]"
									:score4="csrAverageScore[3]"
									:title="`Average Sustainability Score for Your Connections`"
									class="sustainabilityScore"
								/>
								<v-btn style=" width: 75%; align-self: center; margin-bottom: 50px; margin-top: -30px;" color="primary" to="/csr/request"> 
									<v-icon left>fas fa-user-plus</v-icon>
									<span>Invite supplier to fill out Sustainability form</span>
								</v-btn>
							</v-col>
						</v-row>
						
					</v-col>
				</v-row>
			</v-container>
			<v-dialog v-model="supportOrixe" max-width="800px">
				<v-card class="text-center" style="padding: 0 20px 80px 20px;">
					<v-toolbar
						elevation="0"
						class="pr-0"	
					>
						<v-col align="right" class="pr-1">
							<v-btn icon @click="supportOrixe = false">
								<v-icon large color="primary">fas fa-thin fa-times</v-icon>
							</v-btn>
						</v-col>
					</v-toolbar>
					<br>
					<span class="text-h6">If you need help you can contact support: <b class="primary--text">support@orixe.eu</b></span><br>
					<span class="text-h6">or</span><br>
					<!-- <span class="text-h6">
						<v-btn 
							color="orangeButton"
							class="white text-h7"
							target="_blank"
						><a target="_blank" href="https://www.orixe.eu/knowledge-page" style="text-decoration: none; color: white">Info & FAQ page <v-icon class="pl-2">fas fa-external-link-alt</v-icon></a></v-btn>
					</span> -->
					<span class="text-h6">
						<v-btn 
							color="orangeButton"
							class="white text-h7"
							:to="'/knowledge'"
							target="_blank"
							>
							<a style="text-decoration: none; color: white">Knowledge page<v-icon class="pl-2">fas fa-external-link-alt</v-icon></a>
						</v-btn>
					</span>
					<span class="text-h6">
						<v-btn 
							color="orangeButton"
							class="white text-h7 ml-10"
							target="_blank"
						><a target="_blank" href="https://outlook.office.com/book/BookaDemo1@orixe.eu/" style="text-decoration: none; color: white">Book a Teams meeting<v-icon class="pl-2">fas fa-external-link-alt</v-icon></a></v-btn>
					</span>
				</v-card>
			</v-dialog>
			<!--
			Old module for sustainability, can most probably be removed. 
			<v-dialog v-model="dialog" max-width="500px">
				<v-card>
					<v-card-title>What would you like to access?</v-card-title>
					<v-card-text>
						<v-row class="contentRow">
							<v-btn
								width="60%"
								class="mx-auto"
								color="success"
								@click="redirect('/csr')"
							>
								Sustainability
							</v-btn>
						</v-row>
						<v-row class="contentRow">
							<v-btn
								width="60%"
								class="mx-auto"
								color="success"
								@click="redirect('/emissions')"
							>
								Emission
							</v-btn>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-btn color="error" text outlined @click="dialog = false"
							>Close</v-btn
						>
					</v-card-actions>
				</v-card>
			</v-dialog>
			-->
			<orixe-footer/>
		</VMain>
		<test-error />
	</v-app>
</template>

<script>
import router from "../router"
import { mapGetters, mapActions } from "vuex"
import BillingAPI from "../api/billing"
import CsrAPI from "../api/csr/csr"
import SupplierAPI from "../api/csr/supplier"
import LoadingState from "../consts/LoadingState"

export default {
	name: "Login",
	data() {
		return {
			unlocked: false,
			billingPortalURL: null,
			//billingPortalURL2: null,
			csrScore: [null, null, null, null],
			csrAverageScore: [null, null, null, null],
			dialog: false,
			teamMenuActive: false,
			supportOrixe: false,
			connections: [],
		}
	},
	computed: {
		...mapGetters("notifications/notifications", ["getNotifications"]),
		auditUnlocked() {
			return this.$accessToRoute("/audit")
		},
		auditFlowDownUnlocked() {
			return this.$accessToRoute("/auditflowdown")
		},
		traceUnlocked() {
			return this.$accessToRoute({ name: "Trace" })
		},
		connectionsUnlocked() {
			return this.$accessToRoute("/connections")
		},
		...mapGetters("user", ["isLoggedIn", "getUser"]),
		username() {
			return this.getUser.username
		},
		name() {
			return this.getUser.firstname && this.getUser.lastname
				? this.getUser.firstname + " " + this.getUser.lastname
				: this.clientName
		},
		clientID() {
			return this.getUser.clientID
		},
		clientName() {
			return this.getUser.clientName
		},
		clientUserCount() {
			return this.getUser.clientUserCount
		}
	},
	watch: {
		isLoggedIn: function(newval) {
			if (newval == false) {
				router.push("/login")
			}
		}
	},
	methods: {
		...mapActions("notifications/notifications", [
			"deleteAllNotifications",
			"deleteNotification",
			"loadNotifications"
		]),
		dialogSupport(){
			this.supportOrixe = true
		},
		showOptions() {
			this.dialog = true
		},
		redirect(path) {
			this.$router.push(path)
		},
		getGreetingTime() {
			let n = this.$moment()
			if (n && n.isValid()) {
				var e = parseFloat(n.format("HH"))
				return e >= 12 && e <= 17
					? "afternoon"
					: e >= 17
						? "evening"
						: "morning"
			}
		},
		getBillingPortal() {
			BillingAPI.getBillingPortalURL().then(url => {
				if (url) {
					this.billingPortalURL = url
				}
			})
		},
		// postBillingPortal() {
		// 	BillingAPI.postBillingPortalURL().then(url => {
		// 		if (url) {
		// 			this.billingPortalURL2 = url
		// 		}
		// 	})
		// },
		getCsrScore() {
			this.csrScore = [null, null, null, null]

			CsrAPI.getCSRForm()
				.then(data => {
					if (data.csrID) {
						CsrAPI.getCSRAssessment(data.csrID)
							.then(result => {
								let csr = result[0]
								if (csr) {
									this.csrScore = [
										Math.round(csr.score1),
										Math.round(csr.score2),
										Math.round(csr.score3),
										Math.round(csr.score4)
									]
								}
							})
							.catch(error => {
								console.log(error)
							})
					}
				})
				.catch(err => {
					console.log(err)
				})
		},
		loadItems() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			SupplierAPI.getSuppliers()
				.then((data) => {
					this.connections = []
					for (let entry of data) {
						this.connections.push({
							clientID: entry.clientID,
							name: entry.name,
							csr: entry.csr,
							averageConnectionScores: entry.averageSupplierScores,
							remove: null,
						})
					}
					this.getCsrAverageScore() // Calculating average score of all suppliers
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		getCsrAverageScore(){
			var count, sumScore1, sumScore2, sumScore3, sumScore4
			count = sumScore1 = sumScore2 = sumScore3 = sumScore4 = 0
			for(let connection of this.connections){
				if(connection.csr){
					count++
					sumScore1 += connection.csr.score1 
					sumScore2 += connection.csr.score2 
					sumScore3 += connection.csr.score3 
					sumScore4 += connection.csr.score4 
				}
			}
			const averageScore1 = sumScore1/count 
			const averageScore2 = sumScore2/count 
			const averageScore3 = sumScore3/count 
			const averageScore4 = sumScore4/count 

			this.csrAverageScore = [averageScore1, averageScore2, averageScore3, averageScore4]
		}
	},
	mounted() {
		this.getBillingPortal()
		//this.postBillingPortal()
		this.getCsrScore()
		this.loadItems()
		this.getCsrAverageScore()
		this.loadNotifications({})
	}
}
</script>

<style scoped>
.portaldisabled {
	background-color: #0b707844 !important;
	background-image: linear-gradient(
		45deg,
		white 25%,
		#0b707844 25.5%,
		#0b707844 50%,
		white 50.5%,
		white 75%,
		#0b707844 75.5%,
		#0b707844
	);
	background-size: 20px 20px;
	background-repeat: repeat;
}

.text-transform-none {
  text-transform:none !important;
}

.sustainabilityScore{
	transform: scale(0.7);
	margin-top: -40px;
}

</style>
